import { Flex, Space, Typography } from 'antd';
import React from 'react';
import { useSelector } from 'react-redux';
import { EnvironmentOutlined } from '@ant-design/icons';
import restaurantSelector from '../../redux/selectors/restaurantSelector';
import {
  getBranchById,
  getWhatsappUrl,
} from '../../utils/branches';

import colors from '../../utils/colors';
import './UsersWelcome.css';

function UsersWelcome() {
  const { number } = useSelector(restaurantSelector);
  const branch = getBranchById(number);

  return (
    <div id="welcome" className="container w-100 h-100">
      <Flex className="container-welcome" vertical align="start" justify="center" style={{ minHeight: '100%' }}>

        <Flex vertical className="welcome-copy">
          <span className="hero-badge">Ambiente deportivo &amp; familiar</span>
          <Typography.Title level={1} style={{ color: 'white' }} className="title-welcome">
            TU RESTAURANTE DEPORTIVO
          </Typography.Title>
          <div className="hero-accent" aria-hidden="true" />
          <Typography.Title level={2} style={{ color: 'white' }} className="subtitle-welcome">
            DISFRUTA LOS MEJORES
            {' '}
            <span className="subtitle-emphasis">TACOS</span>
            ,
            {' '}
            <span className="subtitle-emphasis">HAMBURGUESAS</span>
            {branch.hasBreakfast ? (
              <>
                ,
                {' '}
                <span className="subtitle-emphasis">CORTES</span>
                {' '}
                Y
                {' '}
                <span className="subtitle-emphasis">DESAYUNOS</span>
              </>
            ) : (
              <>
                {' '}
                Y
                {' '}
                <span className="subtitle-emphasis">CORTES</span>
              </>
            )}
            . MIENTRAS VES TUS DEPORTES FAVORITOS.
          </Typography.Title>
        </Flex>
        <Flex justify="start" className="welcome-actions">
          <a
            href={getWhatsappUrl(branch, 'Me gustaría reservar una mesa')}
            target="_blank"
            rel="noopener noreferrer"
            style={{ fontWeight: 600, borderRadius: 100, color: '#0F0F0F', backgroundColor: colors.primary[0], textDecoration: 'none' }}
            aria-label="Reservar mesa en Taquito Grill"
            className="d-flex justify-content-center align-items-center button-welcome"
          >
            <Space>
              <EnvironmentOutlined />
              RESERVAR MESA
            </Space>
          </a>
        </Flex>
      </Flex>
    </div>
  );
}

export default UsersWelcome;
